import React from "react";
import { ModalContext, ModalContextConsumer } from "../contexts/modal_context.js";
import { ModalTypeConfirm } from "../base/modals/constants.js";

/**
 * Use for showing modal windows
 * @component
 * @category HOC
 * @param providedProps
 * @param {func(type, params)} providedProps.showModal - Function for showing modal by type
 * @param {func(params)} providedProps.showConfirmModal - Function for showing confirmation modal
*/
const WithShowModal = (Component) => {

  class WithShowModal extends React.Component {

    showModal = (type, modalInfo) => {
      this.context.showModal(type, modalInfo)
    }

    showConfirmModal = (modalInfo) => {
      this.showModal(ModalTypeConfirm, modalInfo);
    } 

    render() {
      return (
        <ModalContextConsumer>
          { context => 
            <Component { ...this.props } 
                       modalContext = { context } 
                       modalShowed = { context.modalShowed }
                       type = { context.type }
                       modalInfo = { context.modalInfo }
                       showModal = { this.showModal }
                       showConfirmModal = { this.showConfirmModal }/>
          }
        </ModalContextConsumer>
      )
    }
  }

  WithShowModal.contextType = ModalContext;

  return WithShowModal;
};

export default WithShowModal;